import React from 'react';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import './Dashboard.css';

const Dashboard = () => {
  const { user, logout, isAdmin, isDoctor, isReceptionist } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  const dashboardCards = [];

  if (isAdmin || isReceptionist) {
    dashboardCards.push(
      {
        title: 'Pacientes',
        description: 'Gestionar pacientes del centro',
        icon: '👥',
        path: '/patients',
        color: 'blue'
      },
      {
        title: 'Citas',
        description: 'Gestionar citas médicas',
        icon: '📅',
        path: '/appointments',
        color: 'green'
      }
    );
  }

  if (isAdmin || isReceptionist) {
    dashboardCards.push(
      {
        title: 'Catálogos',
        description: 'Ver y compartir catálogos de productos',
        icon: '📚',
        path: '/catalogs',
        color: 'cyan'
      }
    );
  }

  if (isAdmin) {
    dashboardCards.push(
      {
        title: 'Médicos',
        description: 'Gestionar médicos del centro',
        icon: '👨‍⚕️',
        path: '/doctors',
        color: 'purple'
      },
      {
        title: 'Usuarios',
        description: 'Gestionar usuarios del sistema',
        icon: '👤',
        path: '/users',
        color: 'indigo'
      },
      {
        title: 'Historias Médicas',
        description: 'Gestionar historias médicas',
        icon: '📋',
        path: '/medical-history',
        color: 'teal'
      },
      {
        title: 'Inventario',
        description: 'Gestionar productos de óptica',
        icon: '👓',
        path: '/inventory',
        color: 'orange'
      },
      {
        title: 'Calculadora',
        description: 'Administrar calculadora de precios',
        icon: '🔢',
        path: '/calculator-admin',
        color: 'pink'
      },
      {
        title: 'Reportes',
        description: 'Ver reportes y estadísticas',
        icon: '📊',
        path: '/reports',
        color: 'red'
      }
    );
  }

  if (isDoctor) {
    dashboardCards.push(
      {
        title: 'Mis Pacientes',
        description: 'Ver pacientes asignados',
        icon: '👥',
        path: '/my-patients',
        color: 'blue'
      },
      {
        title: 'Mis Citas',
        description: 'Ver mi agenda de citas',
        icon: '📅',
        path: '/my-appointments',
        color: 'green'
      },
      {
        title: 'Historias Médicas',
        description: 'Gestionar historias médicas',
        icon: '📋',
        path: '/medical-history',
        color: 'purple'
      }
    );
  }

  return (
    <div className="dashboard">
      <nav className="dashboard-nav">
        <div className="container">
          <div className="nav-content">
            <div className="nav-brand">
              <h2>COL2C</h2>
            </div>
            <div className="nav-user">
              <span className="user-name">
                {user?.firstName} {user?.lastName}
              </span>
              <span className="user-role">{user?.role}</span>
              <button onClick={() => navigate('/profile')} className="btn btn-secondary btn-sm">
                Mi Perfil
              </button>
              <button onClick={handleLogout} className="btn btn-secondary btn-sm">
                Cerrar Sesión
              </button>
            </div>
          </div>
        </div>
      </nav>

      <div className="dashboard-content">
        <div className="container">
          <div className="dashboard-header">
            <h1>Bienvenido, {user?.firstName}</h1>
            <p>Sistema de Gestión - Centro Oftalmológico Los Dos Caminos</p>
          </div>

          <div className="dashboard-grid">
            {dashboardCards.map((card, index) => (
              <div
                key={index}
                className={`dashboard-card dashboard-card-${card.color}`}
                onClick={() => navigate(card.path)}
              >
                <div className="card-icon">{card.icon}</div>
                <h3>{card.title}</h3>
                <p>{card.description}</p>
              </div>
            ))}
          </div>

          {dashboardCards.length === 0 && (
            <div className="empty-state">
              <p>No tienes acceso a módulos del sistema.</p>
              <p>Contacta al administrador para obtener permisos.</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
